const PRODUCTION_API_BASE_URL =
  'https://verissa-api-production.up.railway.app/api';

const isBrowserLocalhost =
  typeof window !== 'undefined' &&
  /localhost|127\.0\.0\.1/.test(window.location.hostname);

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  (isBrowserLocalhost ? 'http://localhost:4001/api' : PRODUCTION_API_BASE_URL);
